import Icon from '../components/Icon.vue'

Icon.register({"beer":{"width":1664,"height":1792,"paths":[{"d":"M640 896v-384h-256v256q0 53 37.5 90.5t90.5 37.5h128zM1664 1344v192h-1152v-192l128-192h-128q-159 0-271.5-112.5t-112.5-271.5v-320l-64-64 32-128h480l32-128h960l32 192-64 32v800z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/beer.js
// module id = 733
// module chunks = 0